import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
export var extractProgram = function extractProgram(program) {
  return program === null || program === void 0 ? void 0 : program.data;
};
export var getIncludedSchool = function getIncludedSchool(programData, includedRessources) {
  var _programData$relation;
  return programData !== null && programData !== void 0 && (_programData$relation = programData.relationships.school) !== null && _programData$relation !== void 0 && _programData$relation.data ? includedRessources === null || includedRessources === void 0 ? void 0 : includedRessources.find(function (i) {
    var _programData$relation2, _programData$relation3;
    return i.type === ((_programData$relation2 = programData.relationships.school) === null || _programData$relation2 === void 0 ? void 0 : _programData$relation2.data.type) && i.id === ((_programData$relation3 = programData.relationships.school) === null || _programData$relation3 === void 0 ? void 0 : _programData$relation3.data.id);
  }) : null;
};
export var getProgramRequirements = function getProgramRequirements(programData, includedRessources) {
  return includedRessources === null || includedRessources === void 0 ? void 0 : includedRessources.find(function (i) {
    var _programData$relation4, _programData$relation5;
    return i.type === ((_programData$relation4 = programData.relationships.programRequirement) === null || _programData$relation4 === void 0 ? void 0 : _programData$relation4.data.type) && i.id === ((_programData$relation5 = programData.relationships.programRequirement) === null || _programData$relation5 === void 0 ? void 0 : _programData$relation5.data.id);
  });
};
export function getProgramEnglishRequirementExceptions(programData, includedRessources) {
  var _programData$relation6;
  return (_programData$relation6 = programData.relationships.programEnglishRequirementExceptions) !== null && _programData$relation6 !== void 0 && _programData$relation6.data.length ? includedRessources === null || includedRessources === void 0 ? void 0 : includedRessources.filter(function (i) {
    var _programData$relation7, _programData$relation8;
    return i.type === ((_programData$relation7 = programData.relationships.programEnglishRequirementExceptions) === null || _programData$relation7 === void 0 ? void 0 : _programData$relation7.data[0].type) && ((_programData$relation8 = programData.relationships.programEnglishRequirementExceptions) === null || _programData$relation8 === void 0 ? void 0 : _programData$relation8.data.map(function (p) {
      return p.id;
    }).includes(i.id));
  }) : null;
}
var getEnglishProgramRelationship = function getEnglishProgramRelationship(programData) {
  var _programData$relation9, _programData$relation10;
  return programData === null || programData === void 0 ? void 0 : (_programData$relation9 = programData.relationships) === null || _programData$relation9 === void 0 ? void 0 : (_programData$relation10 = _programData$relation9.englishProgram) === null || _programData$relation10 === void 0 ? void 0 : _programData$relation10.data;
};
export function getPrerequisiteEnglishProgramRequirements(programData, includedRessources) {
  return getEnglishProgramRelationship(programData) ? includedRessources === null || includedRessources === void 0 ? void 0 : includedRessources.find(function (i) {
    var _fullProgram$relation;
    var programRelationship = getEnglishProgramRelationship(programData);
    if (!programRelationship) {
      return null;
    }
    var fullProgram = includedRessources === null || includedRessources === void 0 ? void 0 : includedRessources.find(function (pi) {
      return pi.type === programRelationship.type && pi.id === programRelationship.id;
    });
    if (!fullProgram) {
      return null;
    }
    var requirements = (_fullProgram$relation = fullProgram.relationships.programRequirement) === null || _fullProgram$relation === void 0 ? void 0 : _fullProgram$relation.data;
    if (!requirements) {
      return null;
    }
    return i.type === requirements.type && requirements.id === i.id;
  }) : null;
}
export function getPrerequisiteEnglishRequirementExceptions(programData, includedRessources) {
  return getEnglishProgramRelationship(programData) ? includedRessources === null || includedRessources === void 0 ? void 0 : includedRessources.filter(function (i) {
    var _fullProgram$relation2;
    var programRelationship = getEnglishProgramRelationship(programData);
    if (!programRelationship) {
      return null;
    }
    var fullProgram = includedRessources === null || includedRessources === void 0 ? void 0 : includedRessources.find(function (pi) {
      return pi.type === programRelationship.type && pi.id === programRelationship.id;
    });
    if (!fullProgram) {
      return null;
    }
    var requirements = (_fullProgram$relation2 = fullProgram.relationships.programEnglishRequirementExceptions) === null || _fullProgram$relation2 === void 0 ? void 0 : _fullProgram$relation2.data;
    if (!(requirements !== null && requirements !== void 0 && requirements.length)) {
      return null;
    }
    return i.type === requirements[0].type && requirements.map(function (i) {
      return i.id;
    }).includes(i.id);
  }) : null;
}
export var getSchoolPhotos = function getSchoolPhotos(includedRessources) {
  return includedRessources === null || includedRessources === void 0 ? void 0 : includedRessources.filter(function (i) {
    return i.type === 'school_photo';
  });
};
export var getProgramIntakes = function getProgramIntakes(includedRessources) {
  return includedRessources === null || includedRessources === void 0 ? void 0 : includedRessources.filter(function (i) {
    return i.type === 'program_intake' && i.generalStatus !== 'closed';
  });
};